var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Select } from '@web/components/ui/Form/Select';
import { useUserContext } from '@web/contexts/User';
import { findTimezoneOption, getTimezoneOptions } from '@web/utility/timezones';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
export function ProfileTimezones(_a) {
    var onUpdate = _a.onUpdate;
    var t = useTranslation().t;
    var currentUser = useUserContext().currentUser;
    var timezoneOptions = useMemo(function () { return getTimezoneOptions(currentUser === null || currentUser === void 0 ? void 0 : currentUser.timezone); }, [currentUser === null || currentUser === void 0 ? void 0 : currentUser.timezone]);
    var selectedTimeZone = findTimezoneOption(currentUser === null || currentUser === void 0 ? void 0 : currentUser.timezone, timezoneOptions);
    var handleChange = function (selectedOption) {
        if (!currentUser)
            return null;
        if (selectedOption.id) {
            onUpdate(__assign(__assign({}, currentUser), { timezone: String(selectedOption.id) }));
        }
    };
    return (_jsxs("div", __assign({ className: "flex flex-col md:flex-row gap-6 sm:rounded-lg p-3 sm:p-6 shadow" }, { children: [_jsxs("div", __assign({ className: "md:w-1/2 text-xs sm:text-sm text-gray-500" }, { children: [_jsx("h3", __assign({ className: "text-sm sm:text-xl leading-6 font-semibold text-gray-900" }, { children: t('timezone.title') })), _jsx("div", __assign({ className: "mt-3" }, { children: t('timezone.description') }))] })), _jsx("div", __assign({ className: "max-w-72 min-w-[350px]" }, { children: _jsx(Select, { selected: selectedTimeZone, onChange: handleChange, options: timezoneOptions, withSearchField: true }) }))] })));
}
export default ProfileTimezones;
